//HEAD IS DONE
let Head= {
    None:{
        Name: "None",
        Stats:[0,0,0,0,0]
    },
    Muscle:{
        Name: "Muscle",
        Stats:[2,0,0,0,-2]
    },
    Turbo:{
        Name: "Turbo",
        Stats:[0,2,0,0,-2]
    },
    Cannon:{
        Name: "Cannon",
        Stats:[0,0,2,0,-2]
    },
    Chain:{
        Name: "Chain",
        Stats:[0,-2,0,2,0]
    },
    Trick:{
        Name: "Trick",
        Stats:[0,0,0,-2,2]
    },
    Bushido:{
        Name: "Bushido",
        Stats:[-1,-1,-1,4,-1]
    },
    Knight:{
        Name: "Knight",
        Stats:[+2,-2,+1,+1,-2]
    },
    Shellfish:{
        Name: "Shellfish",
        Stats:[-2,+2,-1,-2,+2]
    }
};

export default Head